exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "body,html{background:#e9ecef}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/views/Forgot_pass.vue"],"names":[],"mappings":"AACA,UAEE,kBAAoB,CACrB","file":"Forgot_pass.vue","sourcesContent":["\nhtml,\nbody {\n  background: #e9ecef;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dc75ab94","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Forgot_pass.vue
// module id = 1231
// module chunks = 43